import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState, useCallback, Fragment, useRef } from 'react';
import './tableButtons.scss';
import _ from 'lodash'
import 'jspdf-autotable';

import { Grid, Icon } from '@mui/material';
import { Button } from "@gpstrackit/react-controls";
import DragDropList from '../DragDropList'
import CustomCheckbox from '../CheckBox'
import AreaMenu, { Area, Menu } from '../AreaMenu/index.js';

export const TableButtons = (props) => {
    const {
        messages,
        tableRef,
        columns,
        onChangeColumns,
        buttons = [
            'export',
            'orderColumn'
        ],
        lockedColumns = false,
        externalExport,
        noCSV,
        noPDF,
    } = props;

    const exportMenuRef = useRef();
    const orderColumnMenuRef = useRef();

    const availableButtons = {
        export: (key) => {
            return (
                <AreaMenu key={key} ref={exportMenuRef} id="exportTable" clickClose>
                    <Area>
                        <div onClick={(e) => e.stopPropagation()}>
                            <Button
                                type="icon"
                                icon="get_app"
                                tooltip={messages['export']}
                                onClick={() => {
                                    exportMenuRef.current?.toggle(true);
                                    orderColumnMenuRef.current?.toggle(false);
                                }}
                            />
                        </div>
                    </Area>
                    <Menu className="menu-columns">
                        <ul >
                            {!noCSV && <li onClick={() => { externalExport ? externalExport('CSV', 'All') : tableRef.current.exportCSV('All') }}>{messages ? messages['exportCSV'] : 'Export CSV All Columns'}</li>}
                            {!noCSV && <li onClick={() => { externalExport ? externalExport('CSV', 'Partial') : tableRef.current.exportCSV('Partial') }}>{messages ? messages['exportCSVVisible'] : 'Export CSV Visible Columns'}</li>}
                            {!noPDF && <li onClick={() => { externalExport ? externalExport('PDF') : tableRef.current.exportPDF() }}>{messages ? messages['exportPDF'] : 'Export PDF'}</li>}
                        </ul>
                    </Menu>
                </AreaMenu>
            )
        },
        orderColumn: (key) => {
            return (
                <AreaMenu key={key} ref={orderColumnMenuRef} id="columnsOrder" clickClose>
                    <Area>
                        <div onClick={(e) => e.stopPropagation()}>
                            <Button
                                type="icon"
                                icon="view_week"
                                tooltip={messages['changeColumnOrder']}
                                onClick={() => {
                                    orderColumnMenuRef.current?.toggle(true);
                                    exportMenuRef.current?.toggle(false);
                                }}
                            />
                        </div>
                    </Area>
                    <Menu style={{ width: 300 }}>
                        <div className="columns-visibility-menu">
                            <div className="options-menu">
                                <Grid container spacing={2}>
                                    <Grid item xs={lockedColumns ? 8 : 10} style={{ display: 'flex', alignItems: 'center' }}>
                                        <span className="options-menu-title">Column</span>
                                    </Grid>
                                    <Grid item xs={2} className="options-menu-icons">
                                        <Icon>visibility</Icon>
                                    </Grid>
                                    {lockedColumns &&
                                        <Grid item xs={2} className="options-menu-icons">
                                            <Icon>lock</Icon>
                                        </Grid>
                                    }
                                </Grid>
                                <hr className="options-menu-separator" />
                            </div>
                            {/* BUG-FIX: Filter out icon columns to prevent invisible Draggables causing index mismatch */}
                            <DragDropList
                                items={columns.filter(col => !col.icon)}
                                keyName="key"
                                itemRenderer={(item) => {
                                    return (
                                        <div className="drag-item-row">
                                            {/* BUG-FIX: Visible drag handle icon on left side */}
                                            <Icon className="drag-item-handle">drag_indicator</Icon>
                                            <Grid container spacing={2} style={{ flex: 1 }}>
                                                <Grid item xs={lockedColumns ? 8 : 10} style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span>{item.title}</span>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <CustomCheckbox
                                                        id={item.key}
                                                        style={{ color: "black" }}
                                                        label={""}
                                                        value={item.show}
                                                        onChange={(checked) => {
                                                            let index = columns.findIndex(x => x.key === item.key)
                                                            let newColumns = [...columns]
                                                            newColumns[index].show = checked

                                                            onChangeColumns(newColumns, checked)
                                                        }}
                                                        inputProps={{ 'aria-label': 'select all desserts' }}
                                                    />
                                                </Grid>
                                                {lockedColumns &&
                                                    <Grid item xs={2}>
                                                        <CustomCheckbox
                                                            id={item.key}
                                                            style={{ color: "black" }}
                                                            label={""}
                                                            value={item.locked}
                                                            onChange={(checked) => {
                                                                let index = columns.findIndex(x => x.key === item.key)
                                                                let newColumns = [...columns]
                                                                newColumns[index].locked = checked

                                                                onChangeColumns(newColumns)
                                                            }}
                                                            inputProps={{ 'aria-label': 'select all desserts' }}
                                                        />
                                                    </Grid>
                                                }
                                            </Grid>
                                        </div>
                                    );
                                }}
                                onDragEnd={(result) => {
                                    if (!result.destination) return;

                                    // BUG-FIX: Map filtered indices back to original columns array
                                    const draggableColumns = columns.filter(col => !col.icon);
                                    const sourceItem = draggableColumns[result.source.index];
                                    const destItem = draggableColumns[result.destination.index];

                                    const newColumns = [...columns];
                                    const sourceIndex = newColumns.findIndex(c => c.key === sourceItem.key);
                                    const destIndex = newColumns.findIndex(c => c.key === destItem.key);

                                    const [reorderedItem] = newColumns.splice(sourceIndex, 1);
                                    newColumns.splice(destIndex, 0, reorderedItem);

                                    onChangeColumns(newColumns);
                                }}
                            />
                        </div>
                    </Menu>
                </AreaMenu>
            );
        }
    };

    return (
        <div style={{ display: 'flex' }}>
            {
                buttons.map((button, key) => {
                    return availableButtons[button](key);
                })
            }
        </div>
    )
}